import React from 'react';
import ClassFeeStructure from './ClassFeeStructure';
import '../../../CommonCSS/SocietyCSS.css'

const ClassFeeStructApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Classwise Fees Structure</h5>
          </div>
        </div>
        <ClassFeeStructure/>
      </div>
    </div >
  );
};

export default ClassFeeStructApp;
